// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__x-I5J","header":"Header_header__19OQc","button":"Header_button__3owoR"};